export default __webpack_public_path__ + "static/media/cert-general-staff-cpttm.691d7f56.jpg";